import { format } from "date-fns"
import { CLEAR_FORM, PAYMENT_FORM } from "../../utils/const"

const initialState: PaymentForm = {
    reference: '',
    bank: '',
    amount: 0,
    date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
    phone: '',
    customerId: '',
    customerIdType: 'J',
    issuingBank: '',
    mobilePayment: false
}

export const paymentFormData = (state = initialState, action: any) => {

    switch (action.type) {

        case PAYMENT_FORM:

            var { key, value } = action.payload

            if (key === 'date')
                value = format(value, 'yyyy-MM-dd HH:mm:ss')

            return {
                ...state,
                [key]: value
            }
        case CLEAR_FORM:
            return initialState
        default:
            return state

    }
}